import { getMaterial as getDataModuleMaterial } from '@perpay-web/fintech/dataModules/fetchCardAccountApplicationForOnboarding';

export const getRoot = (state) => state.ui.cardOnboardingMetal;

export const getMaterial = (state) =>
    getRoot(state).material || getDataModuleMaterial(state);
